import { CIMSModule, CIMSPage, Permission } from 'shared'
import { useProtectedMenuItem } from './useProtectedMenuItem'

export function useConcrete() {
  return useProtectedMenuItem({
    module: CIMSModule.Concrete,
    pages: [
      {
        page: CIMSPage.ConcreteTestSets,
        permission: Permission.ViewConcreteTestSet,
      },
      {
        page: CIMSPage.DocumentChecklists,
        permission: Permission.ViewDocumentChecklistItem,
      },
      {
        page: CIMSPage.ConcreteTestingLabs,
        permission: [Permission.ViewTestingLab, Permission.ViewLabTech],
      },
      {
        page: CIMSPage.ConcreteNotifications,
        permission: Permission.ViewConcreteNotification,
      },
    ],
  })
}
